module.exports = __webpack_public_path__ + "img/Interests.2ae22f3a.svg";